import { DEVELOPER_INVENTORY_LISTING_PATH } from "constants/app-paths";
import { Group, Icon, Link } from "../../components/common";

const Label = ({ label, icon }) => (
  <Group gap="6px" className="text-center">
    <Icon icon={icon} size={20} />
    <p>{label}</p>
  </Group>
);

const getLink = (path, label, icon) => (
  <Link to={path}>
    <Label label={label} icon={icon} />
  </Link>
);

const inventory = (privileges, all, t = () => "") => [
  {
    label: getLink(
      DEVELOPER_INVENTORY_LISTING_PATH,
      t("Inventory"),
      "HiOutlineBuildingOffice"
    ),
    key: "developer-inventory-listing",
    path: DEVELOPER_INVENTORY_LISTING_PATH,
    show: true,
  },
];

const developerMenuItems = (privileges, all, t = () => "") => [
  {
    label: <Link to={DEVELOPER_INVENTORY_LISTING_PATH}>{t("Inventory")}</Link>,
    key: "inventory",
    path: [DEVELOPER_INVENTORY_LISTING_PATH],
    show: true,
    hasSidebar: true,
  },
];

const developerSidebarMenuItems = { inventory };

export default {
  menuItems: developerMenuItems,
  sidebarMenuItems: developerSidebarMenuItems,
};
